export default __webpack_public_path__ + "static/media/pawn_white.50273cc6.svg";